<template>
  <div class="d-flex header-wrapper">
    <img class="logo mr-auto my-1 ml-1" src="@/assets/logo.svg" />

    <div class="d-flex justify-center align-center mr-3">
      <div class="caption mr-1 font-weight-medium">{{ $t('program') }}:</div>
      <div class="caption">{{ program.programLocales[0].title }}</div>
    </div>

    <v-btn
      rounded
      outlined
      class="close-btn"
      small
      depressed
      color="error"
      @click="dialog = true"
    >
      <v-icon>mdi-phone-hangup</v-icon>
    </v-btn>

    <div class="primary duration-wrapper px-1 d-flex align-center font-weight-medium">
      <div class="body-1.5 white--text">{{ duration | minuteSeconds }}</div>
    </div>

    <v-dialog v-model="dialog" max-width="500">
      <div class="white pa-3">
        <div class="body-1 text-center mb-4">
          {{ $t('leavePresentation') }}
        </div>

        <div class="d-flex justify-center">
          <v-btn rounded outlined depressed color="error" class="mr-3 custom-rounded-button" @click="onClose"
            >{{ $t('leave') }}</v-btn
          >

          <v-btn rounded outlined color="primary" class="custom-rounded-button" depressed @click="dialog = false"
            >{{ $t('stay') }}</v-btn
          >
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import i18n from "../../locales/i18n";
export default {
  data() {
    return {
      duration: 0,
      interval: null,
      dialog: false,
    };
  },
  computed: {
    ...mapState({
      roomContent: (state) => state.guide.roomContent,
      roomCreatedAt: (state) => state.twilio.roomCreatedAt,
      program: (state) => state.guide.program,
    }),
  },
  created() {
    const countFrom = moment.utc(this.roomCreatedAt).toDate();

    const now = moment(new Date());

    this.duration = moment(now).diff(countFrom, "seconds");

    this.interval = setInterval(() => {
      this.duration++;
    }, 1000);
  },
  methods: {
    ...mapActions(["disconnect"]),
    onClose() {
      this.disconnect();

      this.$router.push({ path: `/${i18n.locale}` });
    },
  },
  destroyed() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
.header-wrapper {
  border-bottom: 1px solid #e0e0e0;
}


.close-btn {
  height: 30px !important;
  width: 48px !important;
  border-radius: 50% !important;
  margin-top: 1.5em !important;
  margin-bottom: 1em !important;
  margin-right: 0.5em !important; /* Προσθέτει περιθώριο στα δεξιά, σπρώχνοντας το αριστερά */
  /* ... άλλα στυλ ... */
}


.duration-wrapper {
  height: 30px !important;
  width: 48px !important;
  border-radius: 50% !important;
  margin-top: 1.3em !important;
  margin-bottom: 1em !important;
  margin-right: 0.5em !important; /* Προσθέτει περιθώριο στα δεξιά, σπρώχνοντας το αριστερά */
  /* ... άλλα στυλ ... */
}
.custom-rounded-button {
  border-radius: 50% !important;
  display: inline-flex; /* Χρησιμοποίησε inline-flex για να συρρικνωθεί στο μέγεθος του περιεχομένου */
  justify-content: center;
  align-items: center;
  padding: 1.5em 1.5em !important; /* Δημιούργησε τον "κυκλικό" χώρο με padding */
  /* Προαιρετικά: Μπορείς να ορίσεις ένα ελάχιστο πλάτος/ύψος αν θες να υπάρχει ένα minimum μέγεθος */
  /* min-width: 48px;
  min-height: 48px; */
}

.custom-rounded-button span {
  font-size: 0.9rem; /* Προσαρμόσε το μέγεθος γραμματοσειράς αν χρειάζεται */
  white-space: nowrap; /* Εξασφάλισε ότι το κείμενο παραμένει σε μία γραμμή */
}


.logo {
  height: 24px;
}


.program-info {
  border-left: 1px solid #e0e0e0;
}
</style>